import firebase from 'firebase/app';
import 'firebase/analytics';

const analytics = {};

export { analytics, firebase };
